import { Actions, UseFindTheObjectState } from './types';

export const initialState = {
  objects: [],
  pages: {},
  hintTag: undefined,
};

export const reducers = (state: UseFindTheObjectState, action: Actions): UseFindTheObjectState => {
  switch (action.type) {
    case 'SET_OBJECTS':
      return { ...state, objects: action.payload.objects };
    case 'SET_FOUND_OBJECT_TAGS':
      return {
        ...state,
        pages: {
          ...state.pages,
          [action.payload.page]: {
            ...state.pages[action.payload.page],
            foundObjectTags: [
              ...new Set([
                ...(state.pages[action.payload.page]?.foundObjectTags ?? []),
                action.payload.objectTag,
              ]),
            ],
          },
        },
      };
    case 'SET_HINT_TAG':
      return {
        ...state,
        hintTag: action.payload.hintTag,
      };
  }
};
